export const Colors = {
  DemioColor: '#40BB64',
};
